import {
  faArrowsRotate,
  faBarcode,
  faDisplay,
  faFileCirclePlus,
  faQuestion,
} from '@fortawesome/free-solid-svg-icons';
import { CompanionRole } from '@/api';
import { type MaybeRef } from 'vue';
import { useBadgeInfoObject } from '../style/useBadgeInfoObject';
import { type DisplayBadgeType } from '../style/useDisplayBadgeClass';

export const useCompanionRoleInfo = (
  colorType: MaybeRef<DisplayBadgeType> = 'badge',
  role?: MaybeRef<CompanionRole>,
) => {
  const { badgeInfo, getBadgeClass, getBadgeColor, getBadgeIcon, getBadgeTitle, getBadgeInfo } =
    useBadgeInfoObject<CompanionRole>(
      {
        i18nPrefix: 'companion.roles',
        colorMap: {
          [CompanionRole.FILE_SYNC]: 'primary',
          [CompanionRole.BARCODE_SCANNER]: 'info',
          [CompanionRole.OFFER_CREATE]: 'success',
          [CompanionRole.OFFER_DISPLAY]: 'accent',
        },
        iconMap: {
          [CompanionRole.FILE_SYNC]: faArrowsRotate,
          [CompanionRole.BARCODE_SCANNER]: faBarcode,
          [CompanionRole.OFFER_CREATE]: faFileCirclePlus,
          [CompanionRole.OFFER_DISPLAY]: faDisplay,
        },
        defaultColor: 'neutral',
        defaultIcon: faQuestion,
      },
      colorType,
      role,
    );

  return {
    companionRoleInfo: badgeInfo,
    getCompanionRoleTitle: getBadgeTitle,
    getCompanionRoleDescription: (roleValue: CompanionRole) =>
      getBadgeTitle(roleValue, 'description'),
    getCompanionRoleClass: getBadgeClass,
    getCompanionRoleColor: getBadgeColor,
    getCompanionRoleIcon: getBadgeIcon,
    getCompanionRoleInfo: getBadgeInfo,
  };
};
